import React, { useRef } from "react";
import { Button } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const CompanyEmployeeEditModal = (props) => {
	
	const firstname = useRef(null);
	const lastname = useRef(null);
	const email = useRef(null);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		props.employee.firstname = firstname.current.value;
		props.employee.lastname = lastname.current.value;
		props.employee.email = email.current.value;
		props.onSubmit(props.employee);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.employee? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Edit Company Employee
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="firstname">Firstname</InputLabel>
						<Input
							inputRef={firstname}
							id="firstname"
							type="firstname"
							autoComplete="off"
							defaultValue={props.employee? props.employee.firstname : ""}
						/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="lastname">Lastname</InputLabel>
						<Input
							inputRef={lastname}
							id="lastname"
							type="lastname"
							autoComplete="off"
							defaultValue={props.employee? props.employee.lastname : ""}
						/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="email">Email</InputLabel>
						<Input
							inputRef={email}
							id="new_email"
							type="email"
							autoComplete="off"
							defaultValue={props.employee? props.employee.email : 3}
						/>
					</FormControl>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CompanyEmployeeEditModal;